import {PlayClass} from "../models/class-structure/generic/PlayClass";
import {PianoSectionClass} from "../models/class-structure/piano/PianoSectionClass";
import {ClassType} from "../models/types/ClassType";
import {AbstractPlayableContent} from "../../playable/models/AbstractPlayableContent";

export class PlayClassPool {
  private classes: PlayClass[] = [];
  private get classesAsArray() {
    return this.classes.filter((playClass) => playClass !== undefined)
  }

  public reset() {
    this.classes = [];
  }

  public push(playClass: PlayClass) {
    if (this.classes[playClass.id] !== undefined) {
      console.error(`Play Class ${playClass.id} is already in pool, should be replaced instead.`);
    }
    this.classes[playClass.id] = playClass;
  }

  public exists(id: number): boolean {
    return this.classes[id] !== undefined;
  }

  public get(id: number): PlayClass {
    if (this.classes[id] === undefined) {
      console.error(`Play Class ${id} could not be find in pool.`);
    }
    return this.classes[id];
  }

  /**
   * /!\ Quite hard function to use, need a good understanding of class structure
   * Get a play class using a playable content, return the first one that match parameters
   * @param classType
   * @param playableContent
   */
  public getByPlayable(classType: ClassType, playableContent: AbstractPlayableContent): PlayClass {
    const result = this.classesAsArray.find((playClass: PlayClass) => {
      return playClass.type === classType &&
        playClass.playableContent.playableType === playableContent.playableType && playClass.playableContent.id === playableContent.id
    });

    if (result instanceof PlayClass) {
      return result;
    }
    console.error(`play class not found for ${classType} ${playableContent.playableType} ${playableContent.id}`)
    return {} as PlayClass;
  }

  public getPianoSectionClassUsingSectionId(sectionId: number): PianoSectionClass {
    // TODO v2: should check that, because classes is an array and we are using id as key it could be undefined
    return this.classes.filter((playClass) => playClass !== undefined).find(
      (playClass) => playClass.type === 'PIANO_BOTH' && playClass.playableContent.id === sectionId
    )!
  }
}

export const playClassPool = new PlayClassPool();
